import { render, staticRenderFns } from "./selection-mode-camion.vue?vue&type=template&id=04598273&scoped=true&"
import script from "./selection-mode-camion.vue?vue&type=script&lang=js&"
export * from "./selection-mode-camion.vue?vue&type=script&lang=js&"
import style0 from "./selection-mode-camion.vue?vue&type=style&index=0&id=04598273&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04598273",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCheckbox,VSelect})
